import { render, staticRenderFns } from "./CollectionHeaderParagraph.vue?vue&type=template&id=a8064e66&scoped=true&name=collection-header-paragraph&"
import script from "./CollectionHeaderParagraph.vue?vue&type=script&lang=js&"
export * from "./CollectionHeaderParagraph.vue?vue&type=script&lang=js&"
import style0 from "./CollectionHeaderParagraph.vue?vue&type=style&index=0&id=a8064e66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8064e66",
  null
  
)

export default component.exports